<template>
  <!---:width="(rowLen * 100) + '%'" 表格宽度如果需要写死，用上面的-->
  <el-table-column
    :fixed="isLeft"
    :prop="list.ind"
    :resizable="isLeft?false:true"
    :class-name="list.label"
    :ref="list.ind"
    :width="rowWidth && rowWidth[list.label] ? rowWidth[list.label] : isLeft?(rowLen * 160) + '%' : sumWidth || 'auto'"
    :min-width="rowWidth && rowWidth[list.label] ? rowWidth[list.label] : isLeft?(rowLen * 160) + '%' : sumWidth || 'auto'"
    :label="list.label || list.label === 0 ? list.label+'' : '-'">
    <template v-if="list.children && list.children.length > 0">
      <summary-table @goSearch="$emit('goSearch', $event)" :list="item" v-for="(item, index) in list.children" :key="index" :isLeft="isLeft" :lineClamp="lineClamp" :rowWidth="rowWidth" :formdatas="formdatas" :valueConfig="valueConfig" :summaryObj="summaryObj" :sumWidth="sumWidth" :config="config" :reviseObj="reviseObj" :dashboardId="dashboardId" :oneInd="oneInd" :isPartition="isPartition" @setReviseRow="rSetReviseRow" @rSetReviseRow="rSetReviseRow"></summary-table>
    </template>
    <template v-slot:header="scope" >
      <div style="position: relative;" class="summary-header">
        <template v-if="!summaryObj || !summaryObj.headerView || !summaryObj.headerView[list.label]">
          {{ list.label || list.label === 0 ? getLabelValue(list.label) + '' : '-' }}
        </template>
        <template v-if="!list.children">
          <orderAndScreen @goSearch="$emit('goSearch', { filed: list, info: $event })" :info="list" />
        </template>
        <i v-if="(!list.children || list.children.length === 0) && getIconRight(scope.column.realWidth || scope.column.width, list.ind)" class="iconfont icon-you header-mom" :style="lineClampMom[list.ind] ? 'transform:rotate(90deg)' : 'transform:rotate(0deg)'" @click="clampMom(list.ind)" />
      </div>
    </template>
    <template #default="scope" v-if="!list.children || list.children.length === 0">
      <div v-if="getIsRevise(list.ind, getRowIndex(scope))" class="pick-l">
        <template v-if="config.reviseConfig && config.reviseConfig.type === 'pick'">
          <template v-for="it in config.reviseConfig.config">
            <div v-if="isAppenBtn(it, scope.row)" 
            :key="it.i" :id="it.name + list.ind" 
            @click.stop="setRevise(it, list, scope, config.datasName + '_' + config.i + '_' +  (tableIndex || 0))" 
            :class="['pick-l-l', isCheck(list, scope, it)  ? 'pick-l-active' : '']">
              <div class="pick-l-l-x"></div>
              <div class="pick-l-l-n">{{ it.name }}</div>
            </div>
          </template>
        </template>
        <div v-else class="xing-lll">
          <template v-for="it in config.reviseConfig.config">
            <i v-if="isAppenBtn(it, scope.row)" :key="it.i" :class="['iconfont icon-xingxing xing', reviseObj[list.ind + '' + getRowIndex(scope)] && reviseObj[list.ind + '' + getRowIndex(scope)].value.name >= it.name ? 'xing-active' : '']" @click.stop="setRevise(it, list, scope, tableIndex)" />
          </template>
        </div>
      </div>
      <div v-else :style="[(list.config ? numFormat({config:list.config && list.config.configNumber, key:'color', numVal: scope.row[list.ind], isFormatNum: list.config.isFormatNum}) : {}), {'-webkit-line-clamp': lineClampMom[list.ind] ? 'inherit' : lineClamp}, getColorSum(list.label, getFromNum(scope.row[list.ind], summaryObj.configNumber && summaryObj.configNumber[list.label] && summaryObj.configNumber[list.label].separator, summaryObj.configNumber && summaryObj.configNumber[list.label]))]" class="customization-clamp summary-hee">
        {{list.config && scope.row[list.ind] !== '汇总' ? numFormat({config: list.config && list.config.configNumber, key: 'left', isFormatNum: list.config.isFormatNum}) : ''}}
        <span v-if="list.colorConfig" :style="[getColor(list.colorConfig, getFromNum(scope.row[list.ind], list.config && list.config.isFormatNum && list.config.configNumber && list.config.configNumber.separator)), getColorNumber(summaryObj.configNumber && summaryObj.configNumber[list.label], getFromNum(scope.row[list.ind], summaryObj.configNumber && summaryObj.configNumber[list.label] && summaryObj.configNumber && summaryObj.configNumber[list.label].separator, summaryObj.configNumber && summaryObj.configNumber[list.label]))]">
          {{numFormat({config: summaryObj.configNumber && summaryObj.configNumber[list.label], key:'left', isFormatNum: summaryObj.configNumber && !!summaryObj.configNumber[list.label] })}}
          <template v-if="summaryObj && summaryObj.colorConfig && summaryObj.colorConfig[list.label] && summaryObj.colorConfig[list.label].colorType == 3">
            <template v-for="(tt, tti) in getImg(getFromNum(scope.row[list.ind], summaryObj.configNumber && summaryObj.configNumber[list.label] && summaryObj.configNumber[list.label].separator, summaryObj.configNumber && summaryObj.configNumber[list.label]), summaryObj.colorConfig[list.label])">
              <div v-if="tt && typeof tt === 'object'" :key="tti" style="width: 20px;height: 20px;display:inline-block;">
                <icon-module :config="tt"></icon-module>
              </div>
              <template v-else>
                {{ tt }}
              </template>
            </template>
          </template>
          <template v-else>
            {{getFromNum(scope.row[list.ind], summaryObj.configNumber && summaryObj.configNumber[list.label] && summaryObj.configNumber && summaryObj.configNumber[list.label].separator, summaryObj.configNumber && summaryObj.configNumber[list.label])}}
          </template>
          {{numFormat({config:summaryObj.configNumber && summaryObj.configNumber[list.label], key:'right', isFormatNum: summaryObj.configNumber && !!summaryObj.configNumber[list.label]})}}
        </span>
        <span v-else :style="getColorNumber(summaryObj.configNumber && summaryObj.configNumber[list.label], getFromNum(scope.row[list.ind], summaryObj.configNumber && summaryObj.configNumber[list.label] && summaryObj.configNumber[list.label].separator, summaryObj.configNumber && summaryObj.configNumber[list.label]))">
          {{numFormat({config: summaryObj.configNumber && summaryObj.configNumber[list.label], key:'left', isFormatNum: summaryObj.configNumber && !!summaryObj.configNumber[list.label] })}}
          <template v-if="summaryObj && summaryObj.colorConfig && summaryObj.colorConfig[list.label] && summaryObj.colorConfig[list.label].colorType == 3">
            <template v-for="(tt, tti) in getImg(getFromNum(scope.row[list.ind], summaryObj.configNumber && summaryObj.configNumber[list.label] && summaryObj.configNumber[list.label].separator, summaryObj.configNumber && summaryObj.configNumber[list.label]), summaryObj.colorConfig[list.label])">
              <div v-if="tt && typeof tt === 'object'" :key="tti" style="width: 20px;height: 20px;">
                <template v-if="tt.type === 0">
                  <template v-if="tt.img.url !== 'default'">
                    <template
                      v-if="
                        tt.color.value === 'default' ||
                        tt.isColor === false ||
                        tt.img.url.includes('confiles') ||
                        tt.img.url.includes('userfiles')
                      "
                    >
                      <img v-if="tt.img.url" class="icon-module-img" :src="$imgurl + '/' + tt.img.url" />
                    </template>
                    <template v-else>
                      <img class="icon-module-img" :src="tt.img.base64Url" />
                    </template>
                  </template>
                </template>
                <template v-else-if="tt.type === 1">
                  <img class="icon-module-img" :src="config.img.base64Url" />
                </template>
              </div>
              <template v-else>
                {{ tt }}
              </template>
            </template>
          </template>
          <template v-else>
            {{getFromNum(scope.row[list.ind], summaryObj.configNumber && summaryObj.configNumber[list.label] && summaryObj.configNumber[list.label].separator, summaryObj.configNumber && summaryObj.configNumber[list.label])}}
          </template>
          {{numFormat({config:summaryObj.configNumber && summaryObj.configNumber[list.label], key:'right', isFormatNum: summaryObj.configNumber && !!summaryObj.configNumber[list.label]})}}
        </span>
        {{list.config && scope.row[list.ind] !== '汇总' ? numFormat({config: list.config.configNumber, key: 'right', isFormatNum: list.config.isFormatNum}) : ''}}


        <!-- ---------------{{ rowWidth && rowWidth[list.label] ? rowWidth[list.label] : isLeft?(rowLen * 160) + '%':'auto' }} -->
      </div>
    </template>
  </el-table-column>
</template>

<script>
  import numberConfig from '../../utils/numberConfig'
  import { getOrgShowName } from "@/api/global.js";
  import orderAndScreen from '@/components/common/orderAndScreen'
  export default {
    name: "summaryTable",
    mixins: [numberConfig],
    // list 表头数据 isLeft 是否冻结 rowLen 配置里面 row 的数组个数
    props: {
      //- 列表数据
      list: {
        type: Object,
      },
      isLeft: {
        type: Boolean,
        default: false
      },
      rowLen: {
        type: Number,
        default: 1
      },
      lineClamp: {
        type: Number,
        default: 1
      },
      rowWidth: {
        type: Object,
        default: () => {}
      },
      valueConfig: Object,
      formdatas: {
        type: Array,
        default: () => { return [] }
      },
      summaryObj: {
        type: Object,
        default: () => {
          return {}
        }
      },
      sumWidth: String || Number,
      config: Object,
      reviseObj: {
        type: Object,
        default: () => {
          return {}
        }
      },
      dashboardId: String,
      oneInd: Boolean,
      isPartition: Boolean,
      tableIndex: {
        type: String,
        default: ''
      }
    },
    data () {
      return {
        allCheck: '',
        isEdit: false
      }
    },
    watch: {
      'config.upRevise': {
        handler (val) {
          if (val) {
            this.isEdit = true
          } else {
            this.isEdit = false
          }
        },
        immediate: true,
        deep: true
      }
    },
    components:{
      orderAndScreen,
      IconModule: () => import('@/components/common/icon/iconModule.vue'),
    },
    methods: {
      getLabelValue (val) {
        if (Array.isArray(val) && val[0] && (val[0].name ||val[0].realname)) {
          // 是组织或者联系人、角色
          val = val.map(item => {
            if (item && item.organizationId) {
              return getOrgShowName(item)
            } else {
              return item.name || item.realname
            }
          }).join()
        }
        return val
      },
      isCheck (list, scope, it) {
        if (scope.row.isAll) {
          return this.allCheck === it.name
        } else {
          return (this.reviseObj[list.ind + '' + this.getRowIndex(scope)] 
          && this.reviseObj[list.ind + '' + this.getRowIndex(scope)].value.name === it.name 
          || !this.reviseObj[list.ind + '' + this.getRowIndex(scope)] 
          && scope.row && it.name === scope.row[list.ind])
        }
      },
      getRowIndex (scope) {
        let index = this.isPartition ? scope.row.rowIndexNew : scope.row.rowIndex
        if (this.isEdit) index -= 1
        return index
      }
    }

  }
</script>

<style scoped lang="scss">
.xing-lll {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.xing {
    margin-right: 10px;
    color: #D8D8D8;
    font-size: 16px;
}
.xing-active {
    color: #FFD12F;
}

.pick-l {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: center;
}
.pick-l-l {
  display: flex;
  align-items: center;
  margin-right: 16px;
  &:last-child {
    margin-right: 0;
  }
}
.pick-l-l-x {
  background-color: #FFFFFF;
  border: 1px solid #DDE0E6;
  width: 14px;
  min-width: 14px;
  height: 14px;
  border-radius: 50%;
}
.pick-l-l-n {
  // color: #666666;
  // font-weight: 400;
  // font-size: 12px;
  margin-left: 6px;
}
.pick-l-active {
  .pick-l-l-x {
    border: 5px solid #4E86FF;
  }
}
.summary-header {
  :deep(.icon-xia) {
    opacity: 0;
  }
  &:hover {
  :deep(.icon-xia) {
      opacity: 1 !important;
    }
  }
}

:deep(.el-table .el-table__cell.is-hidden>*) {
  visibility: visible !important;
}
  .header-mom {
    position: absolute;
    right: -7px;
    /* right: 3px; */
    top: 0;
    font-size: 12px;
    color: #bababa;
    cursor: pointer;
  }
  .customization-clamp {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  /* -webkit-line-clamp: none; */
  white-space: normal;
  transition: 0.3s;
}
.icon-module-img {
  width: 100%;
  height: 100%;
}
</style>
